import styled from 'styled-components'
import { GRAYSCALE_300, GRAYSCALE_500, WHITE } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = (styled.div`
  display: flex;
  align-items: center;
  padding: 16px 12px;
  border-radius: 8px;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${GRAYSCALE_300};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const IconContainer = (styled.div`
  display: flex;
  align-items: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SearchInput = (styled.input`
  display: flex;
  width: 100%;
  border: none;
  outline: none;
  background-color: ${WHITE};
  color: ${GRAYSCALE_500};
  font-size: 13px;
  font-family: ${INTER.regular};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
